export function parseServerTimestamp(timestamp) {
  if (!timestamp) return NaN;

  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(timestamp);
  return Date.parse(hasTimezone ? timestamp : `${timestamp}Z`);
}
